export function devideInTwoIntegers(num) {
	const firstNum = Math.ceil(num / 2);
	const secondNum = num - firstNum;
	return [firstNum, secondNum];
}
export function divideInNIntegers(num, n) {
  if (num < n) {
    return Array(n).fill(1);
}
  const baseValue = Math.floor(num / n);
  const remainder = num % n;
  const result = [];
  for (let i = 0; i < n; i++) {
      if (i < remainder) {
          result.push(baseValue + 1);
      } else {
          result.push(baseValue);
      }
  }

  return result;
}

export const digitsDecimal2 = (num) => {
  // Check if the input is a valid number
  if (num === '' || num === undefined || num === null || isNaN(num)) {
    return num;
  }

  // Convert the number to a string
  const numStr = num.toString();

  // Check if the number contains a decimal point
  if (numStr.includes('.')) {
    // Split the number into integer and decimal parts
    const [integerPart, decimalPart] = numStr.split('.');

    // If the decimal part has more than 2 digits, format to 2 decimal places
    if (decimalPart.length > 2) {
      return Number(num.toFixed(2));
    }
  }

  // If the number does not have more than 2 decimal places, return it as is
  return num;
};
export const floatFilter = (inputString) => {
  inputString = inputString.trim();
  if (inputString === '') return '';
  
  // Match a valid float number pattern
  const match = inputString.match(/^[+-]?\d*(?:\.\d*)?$/);
  
  if (match) {
    return match[0];
  }

  // If the initial match fails, try to extract a valid float part from the string
  const floatMatch = inputString.match(/[+-]?\d+(\.\d+)?/);
  return floatMatch ? floatMatch[0] : '';
}

export const roundOff = (num, toInt = false) => {
  let roundOff = Math.round(num * 100) / 100;
  if (toInt) {
    roundOff = Math.round(roundOff);
  }
  return roundOff
}

export function safeAdd(a, b, decimals = 2) {
  const factor = Math.pow(10, decimals);
  return (Math.round(a * factor) + Math.round(b * factor)) / factor;
}
export function formatNumber(value) {
  const num = parseFloat(value)
  if (isNaN(num)) return value
  const truncated = Math.trunc(num * 100) / 100
  return Number.isInteger(truncated) ? Math.trunc(truncated) : truncated
}

export const safeNumber = (num) => {
  const n = Number(num);
  if (isNaN(n)) {
    return 0;
  }
  return n;
};

export const withPercentWidths = (columns) => {
  const total = columns.reduce((s, c) => s + c.weight, 0)

  return columns.map(col => ({
    ...col,
    width: `${(col.weight / total) * 100}%`,
  }))
}

export const withPxWidths = (columns, pageWidthPx = 1280) => {
  const total = columns.reduce((s, c) => s + c.weight, 0)

  return columns.map(col => ({
    ...col,
    width: `${(col.weight / total) * pageWidthPx}px`,
  }))
}
